import { render, staticRenderFns } from "./couponUsage.vue?vue&type=template&id=28b6bfe2&scoped=true"
import script from "./couponUsage.vue?vue&type=script&lang=js"
export * from "./couponUsage.vue?vue&type=script&lang=js"
import style0 from "./couponUsage.vue?vue&type=style&index=0&id=28b6bfe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6bfe2",
  null
  
)

export default component.exports